import { useCompleteBlueprintMutation } from '@http';
import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useAppStore } from '@stores';

interface CompleteButtonProps {
  finishesAt: string;
  id: string;
};

export function CompleteButton({ finishesAt, id }: CompleteButtonProps) {
  const [_update, setUpdate] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'Arsenal.Forge' }); 
  const { mutateAsync } = useCompleteBlueprintMutation();
  const { refetch } = useAppStore();

  const canComplete = new Date(finishesAt) < new Date();

  useEffect(() => {
    const interval = setInterval(() => setUpdate(u => u + 1), 1000);
    return () => clearInterval(interval);
  }, []);

  const complete = () => {
    if (!canComplete) return;

    setIsLoading(true);
    mutateAsync({ id }, {
      onError: () => {
        setIsLoading(false);
      },
      onSuccess: () => {
        setIsLoading(false);
        refetch();
      }
    });
  };

  return (
    <Button
      className={`${canComplete ? 'can-buy' : 'text-gray-500'} market-listing-btn border-x-0 flex justify-center`}
      isLoading={isLoading}
      onClick={complete}
    >
      {t(canComplete ? 'claim' : 'inProgress')}
    </Button>
  );
}